;(function($) {

	$(document).ready(function() {

		var questions_form = $('form#questions-form');
		var questions_form_button = questions_form.find('button[type=submit]');
		var transitionEndEvent = 'webkitTransitionEnd oTransitionEnd MSTransitionEnd transitionend';

		if(questions_form.length) {

			if(questions_form.find('.untouched').length !== 0) {
				questions_form_button.attr('disabled', true);
			}

			questions_form.find('input').each(function() {
				var self = $(this);

				self.on('change', function() {
					self.parentsUntil('.form-group').removeClass('untouched');

					if(questions_form.find('.untouched').length === 0) {
						questions_form_button.attr('disabled', false);
					}
				});
			});

			questions_form.on('submit', function(e) {
				e.preventDefault();
				e.stopImmediatePropagation();
				e.stopPropagation();

				questions_form_button.attr('disabled', true).addClass('loading');

				var data = questions_form.serializeArray().reduce(function(obj, item) {
					if(obj[item.name]) {
						if(obj[item.name] instanceof Array) {
							obj[item.name].push(item.value);
						}
						else {
							obj[item.name] = [obj[item.name], item.value];
						}
					}
					else {
						obj[item.name] = item.value;
					}
					return obj;
				}, {});

				data['action'] = 'tc_questions_validation';
				data['nonce'] = questions_validation_params.nonce;

				$.ajax({
					url:      questions_validation_params.admin_url,
					type:     'POST',
					dataType: 'json',
					data:     data,
					success:  function(response, status, jqXHR) {

						questions_form_button.addClass('loaded').on(transitionEndEvent, function() {
							var self = $(this);

							self.off(transitionEndEvent);
							self.removeClass('loading loaded');
						});

						if(response.success) {

							if(response.data.cookie) {
								Cookies.set(response.data.cookie.name, response.data.cookie.value, {
									expires: 1,
									path:    response.data.cookie.path,
									domain:  response.data.cookie.domain
								});
							}

							window.location.href = response.data.redirect;
						}
						else {
							console.error(response.data.error);
						}
					}
				});

				return false;
			});
		}

		$('.register-form #cgu').on('change', function() {
			$('.register-form input[name=register]').attr('disabled', !$(this).is(':checked'));
		});
	});

}(jQuery));
